import { render, staticRenderFns } from "./ClientDomains.vue?vue&type=template&id=d02c2582&scoped=true"
import script from "./ClientDomains.vue?vue&type=script&lang=js"
export * from "./ClientDomains.vue?vue&type=script&lang=js"
import style0 from "./ClientDomains.vue?vue&type=style&index=0&id=d02c2582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02c2582",
  null
  
)

export default component.exports